import React from 'react';
import { captureException } from '@sentry/browser';

function getDomainFromUrl(url) {
  const a = document.createElement('a');
  a.href = url;
  return a.origin;
}

export default function withIframeMessageHub(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isSuccess: false,
        isFailure: false,
        isReady: false,
      };
    }

    componentDidMount() {
      window.addEventListener('message', this.messageListener);
    }

    componentWillUnmount() {
      clearTimeout(this.timeout);
      if (this.iframe) {
        this.iframe.removeEventListener('error', this.onError);
      }
      window.removeEventListener('message', this.messageListener);
    }

    messageListener = (event) => {
      let data;

      if (!this.iframe || event.origin !== getDomainFromUrl(this.iframe.src)) {
        return;
      }

      try {
        data = JSON.parse(event.data);
      } catch (e) {} // eslint-disable-line

      if (data && data.loaded !== undefined) {
        clearTimeout(this.timeout);
        if (data.loaded === false) {
          this.setTimeout();
        }

        this.setState({
          isReady: data.loaded,
        });
      }

      if (data && data.success) {
        this.setState({
          isSuccess: true,
          isFailure: false,
        });
      }

      if (data && data.errors) {
        this.setError();

        if (data.errors.length) {
          captureException(new Error(`Iframe Error: ${data.errors.pop()}`));
        }
      }
    };

    postMessage = (msg) => {
      this.iframe.contentWindow.postMessage(JSON.stringify(msg), getDomainFromUrl(this.iframe.src));
    };

    setError = () => {
      this.setState({
        isReady: true,
        isSuccess: false,
        isFailure: true,
      });
    };

    getIframeRef = (el) => {
      if (!el) {
        return;
      }
      this.iframe = el;
      this.iframe.addEventListener('error', this.setError);
      this.setTimeout();
    };

    setTimeout = () => {
      const tenSeconds = 10000;
      this.timeout = setTimeout(() => {
        this.setError();
        captureException(new Error(`Iframe Error: Timeout`));
      }, tenSeconds);
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          isSuccess={this.state.isSuccess}
          isFailure={this.state.isFailure}
          isReady={this.state.isReady}
          postMessage={this.postMessage}
          getIframeRef={this.getIframeRef}
        />
      );
    }
  };
}
